<template>
  <v-data-table
    dense
    :headers="usageHoursHeaders"
    :items="eventData"
    :items-per-page="-1"
    hide-actions
    disable-initial-sort
    class="elevation-1"
    item-key="event_type"
  >
    <template v-slot:items="props">
      <tr
        @click="() => handleTableRowClick(props)"
        :class="props.item.event_type !== 'Total' ? selectedUsageCategory === props.item.event_type ? 'selected-tr hover-cursor-change' : 'hover-cursor-change' : ''"
      >
        <td>{{ props.item.event_type }}</td>
        <td>{{ props.item.event_hours }}</td>
        <td>{{ percentFormat(props.item.event_percent) }}</td>
      </tr>
    </template>
    <template v-slot:expand="props">
      <v-data-table
        dense
        :headers="categoreyDetailsHeaders"
        :items="props.item.reservation_details"
        :items-per-page="-1"
        hide-actions
        disable-initial-sort
        class="elevation-1 selected-inner-tr"
        :expand="expand"
        item-key="usage_category_details"
      >
        <template v-slot:items="reservation_detail_props">
          <tr class="selected-inner-tr">
            <td>{{ dateFormat(reservation_detail_props.item.service_date) }}</td>
            <td>{{ reservation_detail_props.item.title }}</td>
            <td>{{ reservation_detail_props.item.description || 'N/A' }}</td>
            <td>{{ reservation_detail_props.item.billed_service }}</td>
            <td>${{ reservation_detail_props.item.invoiced }}</td>
            <td>{{ reservation_detail_props.item.billed_hours }}</td>
          </tr>
        </template>
      </v-data-table>
    </template>
  </v-data-table>
</template>
<script>
import { format } from 'date-fns'

export default {
  props: {
    eventData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      selectedUsageCategory: '',
      usageHoursHeaders: [
        {
          text: 'Membership Type',
          value: 'event_type',
          sortable: true,
          align: 'start'
        },
        {
          text: 'Total Hours',
          value: 'event_hours',
          sortable: true
        },
        {
          text: 'Total Hours %',
          value: 'event_percent',
          sortable: true
        }
      ],
      categoreyDetailsHeaders: [
        {
          text: 'Service Date',
          value: 'service_date',
          sortable: true,
          align: 'start',
          class: 'selected-inner-tr'
        },
        {
          text: 'Title',
          value: 'title',
          sortable: true,
          align: 'start',
          class: 'selected-inner-tr'
        },
        {
          text: 'Description',
          value: 'description',
          sortable: true,
          align: 'start',
          class: 'selected-inner-tr'
        },
        {
          text: 'Billed Service',
          value: 'billed_service',
          sortable: true,
          align: 'start',
          class: 'selected-inner-tr'
        },
        {
          text: 'Invoiced',
          value: 'invoiced',
          sortable: true,
          align: 'start',
          class: 'selected-inner-tr'
        },
        {
          text: 'Billed Hours',
          value: 'billed_hours',
          sortable: true,
          align: 'start',
          class: 'selected-inner-tr'
        }
      ]
    }
  },
  methods: {
    percentFormat (percent) {
      return new Intl.NumberFormat('en-US', {
        style: 'percent',
        minimumFractionDigits: 2
      }).format(percent)
    },
    handleTableRowClick (rowProps) {
      if (this.selectedUsageCategory === rowProps.item.event_type) {
        this.selectedUsageCategory = ''
        rowProps.expanded = !rowProps.expanded
        return
      }
      if (rowProps.item.event_type !== 'Total') {
        rowProps.expanded = !rowProps.expanded
        this.selectedUsageCategory = rowProps.item.event_type
      }
    },
    dateFormat (date) {
      return format(date, 'YYYY-MM-DD')
    }
  }
}
</script>
<style>
.selected-tr {
  background-color: #f5c401;
}
.selected-inner-tr {
  background-color: #f7eec7;
}
.hover-cursor-change:hover {
  cursor:pointer
}
</style>
